import { NgModule } from '@angular/core'
import { NodeListWidgetComponent } from './node-list-widget.component'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { SharedModule } from '../../../../shared/shared.module'

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule],
  exports: [NodeListWidgetComponent],
  declarations: [NodeListWidgetComponent]
})
export class NodeListWidgetModule {}
